import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/graphic/file.svg'


const _withScopeId = n => (_pushScopeId("data-v-1f5017c5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "file-wrapper" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["onClick"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-close" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "file" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "casedrive file"
}, null, -1))
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-close" }, null, -1))
const _hoisted_10 = [
  _hoisted_9
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_skeleton_rect = _resolveComponent("app-skeleton-rect")!
  const _component_drive_ui_wrapper = _resolveComponent("drive-ui-wrapper")!

  return (_openBlock(), _createBlock(_component_drive_ui_wrapper, {
    title: _ctx.title,
    hideBorder: _ctx.hideBorder
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          style: _normalizeStyle('height: ' + _ctx.itemHeight + '; margin-bottom: ' + _ctx.itemMargin),
          ref: "fileInputButton",
          class: _normalizeClass(["file-button", [_ctx.isPhoto ? 'photo' : 'file-box']]),
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openPopUp && _ctx.openPopUp(...args)))
        }, [
          _createElementVNode("span", {
            class: _normalizeClass(["icon", _ctx.isPhoto ? 'icon-image-add' : 'icon-upload-file'])
          }, null, 2),
          _createTextVNode(" " + _toDisplayString(_ctx.$localize('drive.file.add')) + " " + _toDisplayString(_ctx.isPhoto ? _ctx.$localize('drive.file.type.photo') : _ctx.$localize('drive.file.type.file')), 1)
        ], 6),
        (_ctx.isPhoto)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.skeletonAmount, (n) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: n,
                  class: "photo",
                  style: _normalizeStyle('height: ' + _ctx.itemHeight + '; margin-bottom: ' + _ctx.itemMargin)
                }, [
                  _createVNode(_component_app_skeleton_rect)
                ], 4))
              }), 128)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.temporaryFiles, (photo) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: photo.id,
                  class: "photo",
                  style: _normalizeStyle('height: ' + _ctx.itemHeight + '; margin-bottom: ' + _ctx.itemMargin)
                }, [
                  _createElementVNode("img", {
                    src: photo.url,
                    alt: "selected photo"
                  }, null, 8, _hoisted_2),
                  (!photo.isProps)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        onClick: ($event: any) => (_ctx.removeFile(photo)),
                        class: "closer"
                      }, _hoisted_5, 8, _hoisted_3))
                    : _createCommentVNode("", true)
                ], 4))
              }), 128))
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.skeletonAmount, (n) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: n,
                  class: "file-box",
                  style: _normalizeStyle('height: ' + _ctx.itemHeight + '; margin-bottom: ' + _ctx.itemMargin)
                }, [
                  _createVNode(_component_app_skeleton_rect)
                ], 4))
              }), 128)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.temporaryFiles, (file) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: file.id,
                  style: _normalizeStyle('height: ' + _ctx.itemHeight + '; margin-bottom: ' + _ctx.itemMargin),
                  class: "file-box"
                }, [
                  _createElementVNode("div", _hoisted_6, [
                    _hoisted_7,
                    (!file.isProps)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          onClick: ($event: any) => (_ctx.removeFile(file)),
                          class: "closer"
                        }, _hoisted_10, 8, _hoisted_8))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("p", null, _toDisplayString(file.name), 1)
                ], 4))
              }), 128))
            ], 64))
      ])
    ]),
    _: 1
  }, 8, ["title", "hideBorder"]))
}